<div class="c-ts-user-header__alert">
    <span>{{i18n.youAreAtTimepotOf(user.name)}}</span>
    <timepot-sealer [userId]="userId"></timepot-sealer>
</div>
